module.exports = __webpack_public_path__ + "static/img/discover1.557f3e89.jpg";